import { render, staticRenderFns } from "./lrAIChatPanel.vue?vue&type=template&id=d20bffc0&"
import script from "./lrAIChatPanel.vue?vue&type=script&lang=js&"
export * from "./lrAIChatPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports